import {OPAC_TAB} from '../opac.directive';
'use strict';

var angular:angular.IAngularStatic =  require('angular');
import {Component, Inject, Input, Output, EventEmitter, SimpleChanges} from 'ng-metadata/core';

import serviceProviders, { LocationsService } from './locations.service';
//your imports go here
import {UserSessionManagerService} from  '../../../../../security/userSessionManager.service';

import {ChangeTabEvent} from '../opac.directive';
import {LocationsFilterService} from '../locationsFilter/locationsFilter.service';
import {RequestService} from '../request/request.service';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';
import {getBackendSystem} from '../../../../../appConfig/appConfigForward';
import {LocationService} from "./location/location.service";
import {MediaQueries} from "../../../../../infra/mediaQueries.service";

const forEach = require('lodash/forEach');
const assign = require('lodash/assign');
const uniq= require('lodash/uniq');
const _get= require('lodash/get');
const cloneDeep = require('lodash/cloneDeep');



@Component({
    selector: 'prm-location-items',
    templateUrl: 'components/search/fullView/getit/opac/locations/location-items.html',
})

export class PrmLocationItems{
    @Input() public loc: Object;
    @Input() public item: Object;
    @Input() public memberInstName: string;
    @Input() public isFiltered: boolean;
    @Input() public isLocationsFilterVisible: boolean;
    @Input() public registerUser:string;
    @Input() public itemToUpdate:string;
    @Input() public serviceScrollId:string;
    @Output() public changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();
    @Input() public enableLibraryLevelList:boolean;

    @Input() public dropDownOptions: Object;
    public isExpandAll:boolean;
    @Input() public filters = {};
    private isSingleLocation:boolean;

    private _servicesAdditionalParams: Object;

    private results : Array<Array<Location>>;
    private unfilteredLoc : Object;

    private manualRegistrationInProgress : boolean  = false;
    private manualRegistrationFailed : boolean = false;
    public ariaLiveMode = 'assertive';
    public expandCollapseAnnouncement = '';

    constructor(private locationsService : LocationsService,
                private locationService : LocationService,
                @Inject('opacLocations') private opacLocations,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService,
                private userSessionManagerService : UserSessionManagerService,
                private locationsFilterService: LocationsFilterService,
                private requestService : RequestService,
                private configurationUtil: ConfigurationUtil,
                private mediaQueries: MediaQueries) {
        this.configurationUtil = configurationUtil;
        this.isExpandAll = false;

    }

    ngOnInit(){
        this.results = this.locationsService.getLocations(this.item);
        let locations = this.results.reduce((prev,cur) => prev.concat(cur));
        this.isSingleLocation = (locations.length == 1);
        this._servicesAdditionalParams= this.requestService.getServicesAdditionalParams(this.item);

        this.$scope.$watch(()=>this.isFiltered, (newVal,oldVal)=>{
            if (!newVal && oldVal) {
                this.clearFilters();
            }
        });

        this.$scope.$watch(()=>this.isLocationsFilterVisible, (newVal,oldVal)=>{
            this.isLocationsFilterVisible = newVal;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['loc'] && changes['loc'].currentValue) {
            this.unfilteredLoc = cloneDeep(this.loc);
        }
    }

    formatTooltip = function(value) {
        if (!value) return '';
        return value.replace(/<br\s*\/?>/gi, '\n');
    };

    isMoreThanOneLoc(item) {
        return item.delivery.holding.length>1;
    }

    public isSuprima(){
        return (this.configurationUtil.getBackendSystem() === 'suprima');
    }

    public isDisplayLocationItem(isMore: boolean, isLast: boolean): boolean {
        return this.isSuprima() ? true : !isMore || !isLast;
    }

    public isDisplayShowMoreItemsButtons(): boolean {
        const totalAmountOfLocationItems: number | undefined = _get(this, 'loc.services.itemInfo.locations[0]["items-size"]', undefined);
        return this.isSuprima() && totalAmountOfLocationItems !== undefined?
            totalAmountOfLocationItems > this.loc.items.length :
            this.currLoc && !this.currLoc.locationNoItems && this.currLoc.isMore;
    }

    isItemsFilterDisable(item) {
        if(this.isSuprima()){
            return false;
        }
        return item.delivery.holding.length>1;
    }

    private getLibraryName(location){
        return this.locationService.getLibraryName(location);

    }


    private getSubLibraryName(location){
        return this.locationService.getSubLibraryName(location);

    }

    get servicesAdditionalParams() {
        return this._servicesAdditionalParams;
    }

    get isFilter() {
        let isEnoughDataForFilters :boolean;
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            isEnoughDataForFilters = this.isFiltered ||
                (_get(this,'loc.items',{}).length>1) ||
                ((_get(this,'dropDownOptions.years',{}).length>1 ||
                _get(this,'dropDownOptions.volumes',{}).length>1 ||
                _get(this,'dropDownOptions.descriptions',{}).length>1));
        }else{
            isEnoughDataForFilters  = this.isSingleLocation;
        }
        return isEnoughDataForFilters;
    }

    public getServiceAdditionalParams(item, service) {
        let params = this.servicesAdditionalParams[service.type];
        if (!params || angular.equals({}, params)) {
            return item.additionalData;
        }
        forEach(item.additionalData, (value, key) => {
            params[key] = value;
        });

        return params;
    }

    public allowService() {
        return this.loc && this.loc.location && (!angular.isDefined(this.loc.location.isValidUser) || this.loc.location.isValidUser);
    }

    private goToLocTabAfterClearFilter(clearStack : boolean,locationsFilterVisible : boolean) {
        let eventData= {
            referer: OPAC_TAB.ITEMS,
            dest: OPAC_TAB.LOCATIONS,
            clearStack: clearStack,
            isFiltered: false,
            filters: {},
            locationsFilterVisible: false
        };

        this.changeTabEvent.emit(eventData);
    }

    private goToLibTabAfterClearFilter(clearStack : boolean) {
        let eventData= {
            referer: OPAC_TAB.ITEMS,
            dest: OPAC_TAB.LIBRARIES,
            clearStack: clearStack,
            isFiltered: false,
            filters: {}
        };

        this.changeTabEvent.emit(eventData);
    }

    public filterClick(){
        this.isLocationsFilterVisible = !this.isLocationsFilterVisible;
        if(!this.isLocationsFilterVisible){
            this.clearFilters(false);
        }
    }

    getlocationsItems(loc, fromShowMore){
        if(this.isFilter || this.locationsFilterService.isFilterClicked){
            return this.locationsService.getLocationsItems([[loc]], fromShowMore, false, this.filters, _get(this.item, 'delivery.hideResourceSharing', false), _get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
        }
        return this.locationsService.getLocationsItems([[loc]], fromShowMore, false, {}, _get(this.item, 'delivery.hideResourceSharing', false), _get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
    }

    public handleExpandCollapseAccessibility(loc) {
        //Disable Aria-Live temporarily
        this.ariaLiveMode = 'off';

        //Set proper announcement
        this.expandCollapseAnnouncement = loc.isExpandAll
            ? 'nui.aria.locationItems.itemsCollapsed'
            : 'nui.aria.locationItems.itemsExpanded';

        setTimeout(() => {
            // Re-enable aria-live after a short delay to restore functionality for row expand action
            this.ariaLiveMode = 'assertive';
            this.expandCollapseAnnouncement = '';
        }, 500);
    };

    toggleExpandAll(loc){
        loc.isExpandAll = !loc.isExpandAll;

        this.currLoc.items.forEach((item)=> {
            item.isExpanded = loc.isExpandAll;
        });

    }

    get currLoc(){
        if (this.loc && this.loc.locationNoItems===undefined){
            this.loc.locationNoItems = true;
        }
        if(this.itemToUpdate && this.isSuprima()){
            let promise = this.locationsService.getItemQueueData(this.itemToUpdate,this.loc.location.organization);
            promise.then((res)=>{
                let newQueue = res.itemQueueString;
                let itemField = this.loc.items.filter((item)=>{return item.item == res.itemId;});
                let status = itemField[0].itemFields[0];
                status =status.substr(0,status.lastIndexOf("("));
                status = status + newQueue;
                itemField[0].itemFields[0] = status;

            });
            this.itemToUpdate = undefined;
        }
        return this.loc;
    }

    get inProgress(){
        return this.locationsService.isItemsResquestInProgress;
    }

    get tabId(){
        return OPAC_TAB.ITEMS;
    }

    public isLoggedIn() {
        return (this.userSessionManagerService.getUserName() &&
        this.userSessionManagerService.getUserName().length > 0);
    }

    public handleFilterEvent($event){
        const filters = {
            ...$event,
            subLocationCode: _get(this.loc, 'location.subLocationCode')
        }
        let promise = this.locationsService.performFilter(filters, this.results, _get(this.item, 'delivery.hideResourceSharing', false), _get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''));
        this.isFiltered = true;
        if (promise){
            promise.then((res)=>{
                if(res.data.itemInfo.results[0].length > 1){
                    this.goToLocTabAfterClearFilter(true,true);
                }else{
                    this.loc = res.data.itemInfo.results[0][0];
                    this.dropDownOptions = this.locationsService.updateFilterDropDownOptions(res.data.possibleFilters,res.data.itemInfo.locations);
                }
//                this.locationsService.getItems(this.loc, false, true, $event.volume, $event.year, $event.description);
            });
        }
    }

    clearFilters(locationsFilterVisible){
        this.isFiltered = false;
        this.isLocationsFilterVisible = false;
        this.locationsService.clearFilters(this.item, true);
        this.dropDownOptions = undefined;
        this.filters = {};
        if(this.enableLibraryLevelList){
            this.goToLibTabAfterClearFilter(true);
        }else if (this.isMoreThanOneLoc(this.item)) {
            this.goToLocTabAfterClearFilter(true,locationsFilterVisible);
        }else if(this.configurationUtil.getBackendSystem() === 'suprima'){
            this.loc = cloneDeep(this.unfilteredLoc);
            this.getlocationsItems(this.loc, false);
        }
    }

    /* Check if there is only one location without other filters are activated */
    public isAnyFilterFilled() {
        if(this.configurationUtil.getBackendSystem() === 'suprima') {
            return true;
        }

        return _get(this.filters,'location') ||
               _get(this.filters,'volume') ||
               _get(this.filters,'year') ||
               _get(this.filters,'description');
    }

    public onChangeTabEvent($event){
        this.changeTabEvent.emit($event);
    }

    showRegisterUser(){
        if(this.isLoggedIn() && getBackendSystem() === 'suprima' && this.registerUser === 'Manual'){
            return true;
        }
        return false;
    }

    private tryReloadWithRegisterUser() {
        // open confirmation dialog
        this.locationsService.tryReloadWithRegisterUser(this.memberInstName, this.reloadWithRegisterUser)
    }

    reloadWithRegisterUser = () => {
        this.registerUser = '';
        this.manualRegistrationInProgress = true;
        this.locationsService.registerManualLinkedUser(this.loc.location.organization, _get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''))
            .then((res) => {
                this.manualRegistrationFailed = !res.userId;
            }).catch((error) => {
                this.manualRegistrationFailed = true;
            }).finally(() => {
                this.manualRegistrationInProgress = false;
            });  
    }

    public expandCollapse(item){
        let sel = getSelection().toString();
        if (sel) {
            return;
        }
        item.isExpanded = !item.isExpanded;
    }

    private getExpandCollapseButtonAriaLabel(item) {
        if(!this.$translate.isReady()) {
            return undefined;
        }
        const label = item.isExpanded ? 'nui.locations.collapse': 'nui.locations.expand';
        return this.$translate.instant(label);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/locationItems.directive.ts